import { Box, Typography, Link, Grid, Paper } from '@mui/material';
import { useLanguage } from '../LanguageContext';

export default function Contact() {
  const { language } = useLanguage();

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#f0f0f0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '40px 20px',
        color: '#333',
      }}>

      <Typography variant="h3" sx={{ fontWeight: 'bold', marginBottom: '30px', color: '#333' }}>
        {language === "en" ? "Contact Us" : "Kapcsolat"}
      </Typography>

      <Grid container spacing={4} sx={{ maxWidth: '1000px' }}>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ padding: '20px' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '3px' }}>
                DDr. habil. {language === "en" ? "Zsuzsanna Agora" : "Agora Zsuzsanna"}
            </Typography>
            <Typography sx={{ fontSize: '16px !important', marginBottom: '10px' }}>
                {language === "en" ? "University of Pécs, Faculty of Cultural Sciences, Education and Regional Development" : "PTE-KPVK Kultúra-Identitás Történelem Interdiszciplináris Kutatócsoport"}
            </Typography>
            <Typography sx={{ marginBottom: '5px' }}>
              <strong>{language === "en" ? "Phone:" : "Telefon:"}</strong> +36 20 590 5077
            </Typography>
            <Typography sx={{ marginBottom: '5px' }}>
              <strong>Email:</strong> dr.susanna.agora@gmail.com
            </Typography>
          </Paper>

          <Paper elevation={3} sx={{ padding: '20px', marginTop: '20px' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '10px' }}>
                {language === "en" ? "Location" : "Helyszín"}
            </Typography>
            <Typography sx={{ fontSize: '18px !important' }}>
              <strong>{language === "en" ? "University of Pécs Faculty of Humanities" : "Pécsi Tudományegyetem Bölcsészettudományi Kar"}</strong>
            </Typography>
            <Typography sx={{ fontSize: '18px !important', marginBottom: '5px' }}>
              <strong>{language === "en" ? "Szántó Building" : "Szántó épület"}</strong>
            </Typography>
            <Typography sx={{ marginBottom: '5px' }}>
              <strong>{language === "en" ? "Address:" : "Cím:"}</strong> Pécs, Szántó Kovács János u. 1/B, 7633
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ overflow: 'hidden', height: '100%' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2768.174163576309!2d18.194322875456542!3d46.06756832180912!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4742b1f31a99c7d7%3A0xd406e2e83c0713d8!2zUMOpY3NpIFR1ZG9tw6FueWVneWV0ZW0gQsO2bGNzw6lzemV0dHVkb23DoW55aSBLYXIgLSBTesOhbnTDsyDDqXDDvGxldA!5e0!3m2!1sen!2shu!4v1745764102917!5m2!1sen!2shu"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen={false}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

//<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2768.174163576309!2d18.194322875456542!3d46.06756832180912!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4742b1f31a99c7d7%3A0xd406e2e83c0713d8!2zUMOpY3NpIFR1ZG9tw6FueWVneWV0ZW0gQsO2bGNzw6lzemV0dHVkb23DoW55aSBLYXIgLSBTesOhbnTDsyDDqXDDvGxldA!5e0!3m2!1sen!2shu!4v1745764102917!5m2!1sen!2shu" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>